import React, { useEffect, useState, useRef } from 'react';

import { connect, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom"
import { Pie, getElementAtEvent} from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import {
	Row,
	Col,
	Modal
} from "react-bootstrap";

const ChartCard16Sat = (props) => {

	const dispatch = useDispatch();
	const history = useHistory();

	const [subject, setSubject] = useState(props.subject)
	const [dataSets, setDataSets] = useState(props.dataValue)
	const [showTableModal, setShowTableModal] = useState(false)
	const [tableData, setTableData] = useState(props.tableData)
	const [setNo, setSetNo] = useState(props.setNumber)
	const [filterTableData, setFilterTableData] = useState([])


	const [backgroundColor, setBackgroundColor] = useState(['#CBF1FA',])
	const [chatData, setChatData] = useState(props.dataSet)
	const [seriesData, setSeriesData] = useState()

	const [overallAvg, setOverallAvg] = useState(0)
	const chartRef = useRef();

	const [standard, setStandard] = useState('')
	const [board_name, setBoard_name] = useState('')

	ChartJS.register(ArcElement, Tooltip, Legend);

	useEffect(() => {
		let getData = localStorage.getItem('userDetails');
		let token = JSON.parse(getData).token;
		let board_name = JSON.parse(getData).board_name;
		let standard = JSON.parse(getData).standard;
		setBoard_name(board_name);
		setStandard(standard);

	}, []);

	useEffect(() => {
		setSeriesData(chatData)
	}, [seriesData, chatData]);

	const data = {
		labels: ["Correct", "Incorrect", "Not attempted"],
		datasets: [
			{
				// data: [10, 2, 2],
				data: [props.dataSet.correct_record, props.dataSet.incorrect_record, props.dataSet.not_attempted],
				// data: [dataSets[2], dataSets[1], dataSets[4],],
				// data: setData0,
				borderWidth: 0,
				backgroundColor: [
					"#00B050",
					"#C00000",
					"#A6A6A6",
				],
				/* hoverBackgroundColor: [
					"#000000",
					"#C00000",
					"#A6A6A6",
				], */
			},
		],
	};


	const options = {
		plugins: {
			legend: {
				legend: true,
				position: "left",
				labels: {
					boxWidth: 20,
					padding: 13,
					useSeriesColors: false,
					usePointStyle: true,
					// pointStyleWidth: 10,
				}
			},
			// legend: false,
			// responsive: true,
			datalabels: {
				color: '#000',
				display: true,
				align: 'center',
				backgroundColor: '#D9D9DB',
				borderRadius: 100,
				padding: 3,
				font: {
					size: 12,
				},
			},
		},
		maintainAspectRatio: false,
		onClick: function (evt, element) {
			const typeName = props.exam_type.toUpperCase()
			history.push({ pathname: `/competitive-subjectwise-analysis-on-set/${typeName}-competitive-subjectwise-analysis-on-set`, state:{exam_type : props.exam_type, setNumber: props.setNumber, subType:props.subType, previousPageName:props.previousPageName} })
			if (element.length > 0) {
				// console.log(element, element[0]._datasetInde)
				// you can also get dataset of your selected element
				// console.log(data.datasets[element[0]._datasetIndex])
			}
		}
		};

		const showSetTableData = () => {
			// console.log("Show Table Data");
			setShowTableModal(true)
			// history.push({ pathname: "/competitive-subjectwise-analysis-on-set" })
		}
	const closeTableModal = () => {
			setShowTableModal(false)
		}

	const MoreDetails = () => {
		const typeName = props.exam_type.toUpperCase()
			history.push({ pathname: `/competitive-subjectwise-analysis-on-set/${typeName}-competitive-subjectwise-analysis-on-set`, state:{exam_type : props.exam_type, setNumber: props.setNumber, subType:props.subType, previousPageName:props.previousPageName} })
		}

	const onClick = (event) => {
			const chartIndex = getElementAtEvent(chartRef.current, event);
			// console.log("EEEEEEEEE", chartIndex)
			// console.log(getDatasetAtEvent(chartRef.current, event));
			// console.log(getElementAtEvent(chartRef.current, event));
			// console.log(getElementsAtEvent(chartRef.current, event));
		}


	return(
		<>
			<Row>
				<Col xl={12}>
					<div className="chart_card_parent">
						<div className="chart_card_heading">{props.pageHeading}</div>
						{seriesData != '' ?
							<>
								<div className="chart_body" >
									<Pie data={data}
										width={100}
										height={50}
										options={options}
										plugins={[ChartDataLabels]}
										// onClick={onClick}

									/>
								</div>
								<div className="bottom_details">
									<div className="btn_details back_btn_color text_black cursorPointer" onClick={MoreDetails}>More Details</div>
									{/* <div className="btn_details details_btn_color text_white cursorPointer" onClick={props.showTableData}>Details</div> */}
									<div className="btn_details details_btn_color text_white cursorPointer" onClick={showSetTableData}>Details</div>
								</div>
							</>
							:
							<div className='dflex flex1 jcc aic'>
								No Data Available
							</div>
						}
					</div>
				</Col>
			</Row>
			<Modal
				className="fade bd-example-modal-lg subscribe-modal"
				//size="sm"
				size="lg"
				show={showTableModal}
			>
				<>
					<div className='modal_container'>
						<div className='modal_Header_container'>
							<div>
								{/* <div className='performer_table_heading'>{props.pageHeading}</div> */}
								<div className='performer_table_heading'>{props.typeName == "NTSE" ? "Score Grid - Set (SAT)" : "Score Grid - Set"  }</div>
								<p>Competitive <i className="fa fa-angle-right assessment_icon_color"></i> {props.typeName}{/* {board_name}: {standard} */}  <i className="fa fa-angle-right assessment_icon_color"></i> {props.pageHeading}</p>
							</div>
							<div className='close_btn cursorPointer' onClick={() => closeTableModal()}>
								<i className="fa fa-times" ></i>
							</div>
						</div>
						<div className='modal_body_container'>
							<table cellpadding="10px" className="performance_table_data">
								<thead>
									<tr>
										<th className="text-center light_sky">Set</th>
										{data.labels.map((item, index) => {
											return (
												<th className="text-center light_sky" key={index}>{item}</th>
											)
										})
										}
									</tr>

								</thead>
								<tbody>
									<tr className='table-cell'>
										<td className="text-center light_gray_1">{setNo}</td>
										{data.datasets[0].data.map((item, index) => {
											return (

												<td className="text-center light_gray_1" key={index}>{item}</td>

											)
										})
										}
									</tr>
								</tbody>

							</table>

						</div>

					</div>
				</>
			</Modal>
		</>
	)
}

export default ChartCard16Sat;